import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Pipe({
    name: 'currencyFormat100',
    pure: false,
    standalone: false
})
export class CurrencyFormat100Pipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }
  transform(value: number | null | undefined): string {
    if (value == null) {
      return (0).toLocaleString(this.translate.currentLang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return (value / 100).toLocaleString(this.translate.currentLang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    // return (value).toLocaleString(this.translate.currentLang, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

}
